import {Box} from "@mui/material";

export const KnowledgeManagerLayout = ({children}) => (
    <Box sx={{height: "100%", width: "100%", minHeight: 0, minWidth: 0, overflow: "auto"}}>
        {children}
    </Box>
);
